import { SystemStyleObject } from '@chakra-ui/react';

// 汎用的なスタイル
export const commonStyle: { [key in string]: SystemStyleObject } = {
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  justifyStart: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  }
};
